import moment from 'moment'

export function formatDate(date) {
  return moment(date).format('DD/MM/YYYY HH:mm:ss')
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(value)
}
